export function isIDCard(id) {
    const regex = /^(?:\d{15}|\d{18}|\d{17}(\d|X))$/;
    return regex.test(id);
}


